// Generated file : do not modify
import { RubriquePaie } from '@/extend/classes/Rubrique';
import { Cotisation } from '@/extend/classes/Paie';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Test de la paie
export class SelectItem {
  // Clé
  public value: string;
  // Valeur
  public text: string;

  constructor() {
    this.value = '';
    this.text = '';
  }
}

export default class TestPaie  {
  // Association
  public association: boolean;
  // Soumis à la TVA pour association
  public soumis: boolean;
  // Convention collective
  public conventionId: number;
  // Liste des conventions
  public conventionArray: SelectItem[];
  // Emploi
  public emploiId: number;
  // Liste des emplois
  public emploiArray: SelectItem[];
  // effectif
  public effectifId: number;
  // Liste des effectifs
  public effectifArray: SelectItem[];
  // Localisation
  public localisationId: number;
  // Liste des localisations
  public localisationArray: SelectItem[];
  // Réduction générale
  public reduction: boolean;
  // Exonération
  public exoneration: boolean;
  // Abattement salarié
  public abattement: boolean;
  // Liste des rubriques
  public rubriqueArray: SelectItem[];
  // Liste des rubriques
  public variableArray: SelectItem[];
  // Rubriques
  public rubriques: RubriquePaie[];
  // Liste des données de paie
  public donneesPaie: SelectItem[];
  // Liste des cotisations
  public cotisationsPaie: Cotisation[];
  // Calcul a effectuer
  public calcul: boolean;
  // Calcule possible
  public canCalcul: boolean;
  // Export possible
  public canExport: boolean;
  // Affichage possible
  public canDisplay: boolean;
  // Abattement possible
  public canAbattement: boolean;

  constructor() {
    this.association = false;
    this.soumis = false;
    this.conventionId = 0;
    this.conventionArray = [];
    this.emploiId = 0;
    this.emploiArray = [];
    this.effectifId = 0;
    this.effectifArray = [];
    this.localisationId = 0;
    this.localisationArray = [];
    this.reduction = false;
    this.exoneration = false;
    this.abattement = false;
    this.rubriqueArray = [];
    this.variableArray = [];
    this.rubriques = [];
    this.donneesPaie = [];
    this.cotisationsPaie = [];
    this.calcul = false;
    this.canCalcul = false;
    this.canExport = false;
    this.canDisplay = false;
    this.canAbattement = false;
  }

  public static fromJson (obj: TestPaie): TestPaie {
    const newTestPaie: TestPaie = new TestPaie();
    newTestPaie.association = obj.association;
    newTestPaie.soumis = obj.soumis;
    newTestPaie.conventionId = obj.conventionId;
    newTestPaie.conventionArray = JSON.parse(JSON.stringify(obj.conventionArray));
    newTestPaie.emploiId = obj.emploiId;
    newTestPaie.emploiArray = JSON.parse(JSON.stringify(obj.emploiArray));
    newTestPaie.effectifId = obj.effectifId;
    newTestPaie.effectifArray = JSON.parse(JSON.stringify(obj.effectifArray));
    newTestPaie.localisationId = obj.localisationId;
    newTestPaie.localisationArray = JSON.parse(JSON.stringify(obj.localisationArray));
    newTestPaie.reduction = obj.reduction;
    newTestPaie.exoneration = obj.exoneration;
    newTestPaie.abattement = obj.abattement;
    newTestPaie.rubriqueArray = JSON.parse(JSON.stringify(obj.rubriqueArray));
    newTestPaie.variableArray = JSON.parse(JSON.stringify(obj.variableArray));
    newTestPaie.rubriques = JSON.parse(JSON.stringify(obj.rubriques));
    newTestPaie.donneesPaie = JSON.parse(JSON.stringify(obj.donneesPaie));
    newTestPaie.cotisationsPaie = JSON.parse(JSON.stringify(obj.cotisationsPaie));
    newTestPaie.calcul = obj.calcul;
    newTestPaie.canCalcul = obj.canCalcul;
    newTestPaie.canExport = obj.canExport;
    newTestPaie.canDisplay = obj.canDisplay;
    newTestPaie.canAbattement = obj.canAbattement;
    return newTestPaie;
  }

  public toJsonTestPaie (): string {
    const json = {
      association: this.association,
      soumis: this.soumis,
      conventionId: this.conventionId,
      conventionArray: this.conventionArray,
      emploiId: this.emploiId,
      emploiArray: this.emploiArray,
      effectifId: this.effectifId,
      effectifArray: this.effectifArray,
      localisationId: this.localisationId,
      localisationArray: this.localisationArray,
      reduction: this.reduction,
      exoneration: this.exoneration,
      abattement: this.abattement,
      rubriqueArray: this.rubriqueArray,
      variableArray: this.variableArray,
      rubriques: this.rubriques,
      donneesPaie: this.donneesPaie,
      cotisationsPaie: this.cotisationsPaie,
      calcul: this.calcul,
      canCalcul: this.canCalcul,
      canExport: this.canExport,
      canDisplay: this.canDisplay,
      canAbattement: this.canAbattement,
    }
    return JSON.stringify(json);
  }

  public fromTestPaie (obj: TestPaie): void {
    this.association = obj.association;
    this.soumis = obj.soumis;
    this.conventionId = obj.conventionId;
    this.conventionArray = obj.conventionArray;
    this.emploiId = obj.emploiId;
    this.emploiArray = obj.emploiArray;
    this.effectifId = obj.effectifId;
    this.effectifArray = obj.effectifArray;
    this.localisationId = obj.localisationId;
    this.localisationArray = obj.localisationArray;
    this.reduction = obj.reduction;
    this.exoneration = obj.exoneration;
    this.abattement = obj.abattement;
    this.rubriqueArray = obj.rubriqueArray;
    this.variableArray = obj.variableArray;
    this.rubriques = obj.rubriques;
    this.donneesPaie = obj.donneesPaie;
    this.cotisationsPaie = obj.cotisationsPaie;
    this.calcul = obj.calcul;
    this.canCalcul = obj.canCalcul;
    this.canExport = obj.canExport;
    this.canDisplay = obj.canDisplay;
    this.canAbattement = obj.canAbattement;
  }

  public compareTestPaie (value: TestPaie): boolean {
    return (this.toJsonTestPaie() == value.toJsonTestPaie());
  }

  public cloneTestPaie (): TestPaie {
    return TestPaie.fromJson(this);
  }

  public static calcul (testPaie: TestPaie): Promise<TestPaie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/testpaies/calcul', testPaie, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(TestPaie.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static display (testPaie: TestPaie): Promise<TestPaie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/testpaies/display', testPaie, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(TestPaie.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(testPaies: TestPaie[]) {
  }
}
